import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { useData } from "../contexts/DataContext";

export const AppFooter = () => {
  const { companySettings } = useData();

  const settings = companySettings || {
    company_name: "CareFleet Transport Ltd",
    company_email: "info@carefleettransport.co.uk",
    contact_phone: "+44 20 7946 0123",
    address: "1 Fleet House, London Road, London, United Kingdom",
  };

  return (
    <footer className="border-t border-[#E2E8F0] bg-white px-6 py-4 md:px-8">
      <div className="flex flex-col gap-3 text-sm text-[#64748B] lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="font-semibold text-[#0F172A]">{settings.company_name}</p>
          <p>Secure transport management for daily operations, live journey visibility, and safeguarding coordination.</p>
        </div>
        <div className="flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center md:gap-4">
          <div className="inline-flex items-center gap-2"><Mail size={14} /> {settings.company_email}</div>
          <div className="inline-flex items-center gap-2"><Phone size={14} /> {settings.contact_phone}</div>
          <div className="inline-flex items-center gap-2"><MapPin size={14} /> {settings.address}</div>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
